export default "__VITE_ASSET__B5KzFsv7__"